import { render, staticRenderFns } from "./title.vue?vue&type=template&id=ca0b0cbc&scoped=true&"
import script from "./title.vue?vue&type=script&lang=js&"
export * from "./title.vue?vue&type=script&lang=js&"
import style0 from "./title.vue?vue&type=style&index=0&id=ca0b0cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0b0cbc",
  null
  
)

export default component.exports